"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimpleDatePicker = SimpleDatePicker;
exports.default = DatePicker;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDatetime = _interopRequireDefault(require("react-datetime"));

var _pickBy = _interopRequireDefault(require("lodash/pickBy"));

var _moment = _interopRequireDefault(require("moment"));

var _Field = _interopRequireDefault(require("../Field"));

var _TextField = require("../TextField");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var renderInput = function renderInput(inputProps) {
  return function (props, openCalendar, closeCalendar) {
    return /*#__PURE__*/_react.default.createElement(_TextField.SimpleTextField, _extends({}, inputProps, props, {
      onFocus: openCalendar // onBlur={closeCalendar}

    }));
  };
};

function SimpleDatePicker(props) {
  return /*#__PURE__*/_react.default.createElement(_reactDatetime.default, _extends({
    renderInput: renderInput(props)
  }, props, {
    value: (0, _moment.default)(props.value)
  }));
} //TODO date range picker


function DatePicker(props) {
  return /*#__PURE__*/_react.default.createElement(_Field.default, _extends({}, props, {
    className: (0, _classnames.default)('frikin-select-field', props.className)
  }), function (fieldProps) {
    return /*#__PURE__*/_react.default.createElement(SimpleDatePicker, _extends({}, (0, _pickBy.default)(props, function (v, k) {
      return k !== 'className';
    }), fieldProps));
  });
}

DatePicker.propTypes = SimpleDatePicker.propTypes = {
  label: _propTypes.default.any,
  value: _propTypes.default.any,
  className: _propTypes.default.string,
  inline: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  danger: _propTypes.default.bool,
  success: _propTypes.default.bool,
  options: _propTypes.default.object,
  size: _propTypes.default.oneOf(['small', 'medium', 'large', 'normal']),
  dateFormat: _propTypes.default.string
};
DatePicker.defaultProps = SimpleDatePicker.defaultProps = {
  onChange: function onChange() {},
  size: 'normal',
  dateFormat: 'MMMM Do YYYY, h:mm:ss a'
};